/**
 * Module dependencies.
 */

import { PageFields } from 'src/types/page-fields';
import {
  QueryObserverBaseResult,
  QueryObserverOptions,
  useQuery
} from 'react-query';
import { fetchPageFields } from './fetch-page-fields';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Result` type.
 */

type Result = QueryObserverBaseResult<PageFields, unknown>;

/**
 * `Options` type.
 */

type Options = QueryObserverOptions<PageFields>;

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-page-fields`;
};

/**
 * `usePageFields` hook.
 */

function usePageFields(options?: Options): Result {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const result = useQuery(
    [actionType(variables), variables],
    () => {
      return fetchPageFields(variables);
    },
    options
  );

  return result;
}

/**
 * Export `usePageFields` hook.
 */

export default usePageFields;
